import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { MyBetsBet } from '../../../my-bets-base/models/my-bets-viewmodels';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ms-my-bets-betslip-sport-competition-name',
    template: `<div class="mybets-betslip-info_sport_competitionName">{{ sportAndCopetitionName }}</div>`,
    standalone: false,
})
export class MyBetsBetslipSportCompetitionNameComponent {
    @Input() bet: MyBetsBet;

    get sportAndCopetitionName(): string {
        const { sportName, leagueName } = this.bet;

        return [sportName, leagueName].filter((name) => name).join(' - ');
    }
}
